import React, { type FC } from 'react';

import { Box, Flex, xcss } from '@atlaskit/primitives';

const overlayContainerStyles = xcss({
	position: 'relative',
});

const overlayStyles = xcss({
	position: 'absolute',
	zIndex: 'card',
	width: '100%',
	height: '100%',
});

const overlayInnerStyles = xcss({
	width: '50%',
	textAlign: 'center',
});

export const OverlayContainer: FC<{ testId?: string; children?: React.ReactNode }> = ({
	children,
	testId,
}) => (
	<Box xcss={overlayContainerStyles} testId={testId}>
		{children}
	</Box>
);

export const Overlay: FC<{ children?: React.ReactNode }> = ({ children }) => (
	<Flex justifyContent="center" alignItems="center" xcss={overlayStyles}>
		<Flex direction="column" alignItems="center" gap="space.100" xcss={overlayInnerStyles}>
			{children}
		</Flex>
	</Flex>
);
